<script setup lang="ts">
import type { AuthenticationType } from '@/types/auth';

defineProps({
	type: {
		type: Number as PropType<AuthenticationType>,
		default: AUTH_FORM.SIGN_IN,
	},
	email: {
		type: String,
		required: true,
	},
});
</script>
<template>
	<div class="text-md text-align-center text-regular">
		<template v-if="type === AUTH_FORM.SIGN_IN">
			We sent a sign in code to
			<b class="text-semibold">{{ email }}</b>. Please check your email, and enter the code below to sign in. Code expires in 15 minutes.
		</template>
		<template v-if="type === AUTH_FORM.SIGN_UP">
			We sent a verification code to
			<b class="text-semibold">{{ email }}</b>. Please check your email, and enter the code below to register. Code expires in 15 minutes.
		</template>
	</div>
</template>
